import Form1 from './Form1';
import Form2 from './Form2';

export default function Form12({ hidden, data,setData, setNoMail, noMail, countries, species, sterilisationStatus, animalSex, prescribers, setActivePrescriber, isSuperuser, activePrescriber,validationLabel,setValidationLabel }) {

    const ActivePrescriber = () => {

        if(activePrescriber){
            return(
                <div className="border-b border-light-gray flex items-center justify-center p-2">
                    <h1 className="text-base">PRESCRIPTEUR ACTIF:</h1>
                    <p className="italic text-dark-green ml-3">{activePrescriber.individual.first_name + activePrescriber.individual.last_name + " - " + activePrescriber.individual.email}</p> 
                </div>
            )
        }
    }

    return (
        <div className={(hidden ? "hidden" : "box-container max-w-[1000px] max-h-[650px] min-h-[650px] overflow-hidden flex flex-col")}>
            <ActivePrescriber />
            <div className="flex flex-row grow">
                <Form1 data={data} setData={setData} noMail={noMail} setNoMail={setNoMail} countries={countries} prescribers={prescribers} isSuperuser={isSuperuser} setActivePrescriber={setActivePrescriber} validationLabel={validationLabel} setValidationLabel={setValidationLabel} />
                <Form2 data={data} setData={setData} species={species} sterilisationStatus={sterilisationStatus} animalSex={animalSex} validationLabel={validationLabel} setValidationLabel={setValidationLabel} />
            </div>
        </div>
    );
}